export const WORKSPACE_SELECTION_STORAGE_KEY = "lead3a.admin.workspaceSelection.v1";
const COMPLEX_SNAPSHOT_FIELDS = ["complexName", "city", "type", "transferNumber", "developer", "rootStatus", "currentSipClientId", "currentSipClient"];
const SIP_SNAPSHOT_FIELDS = ["complexName", "developer", "sipNumber", "transferNumber", "type", "clientStatus", "currentSipClientId", "currentSipClient", "complexStatus"];

export function normalizeTransferNumber(value) {
  return String(value ?? "").trim();
}

function sanitizeSnapshot(snapshot, entityType) {
  if (!snapshot || typeof snapshot !== "object" || Array.isArray(snapshot)) return {};
  const fields = entityType === "complex" ? COMPLEX_SNAPSHOT_FIELDS : SIP_SNAPSHOT_FIELDS;
  return Object.fromEntries(fields.filter((field) => ["string", "number", "boolean"].includes(typeof snapshot[field]) || snapshot[field] === null).map((field) => [field, snapshot[field]]));
}

export function getWorkspaceSelectionKey(item) {
  const complexId = String(item?.complexId || "").trim();

  if (!complexId) return "";

  if (item?.entityType === "complex") {
    return `complex:${complexId}`;
  }

  if (item?.entityType === "sipClient") {
    const sipClientId = String(item?.sipClientId || "").trim();
    return sipClientId ? `sipClient:${complexId}:${sipClientId}` : "";
  }

  if (item?.type === "transfer") {
    const sipClientId = String(item?.sipClientId || "").trim();
    const transferNumber = normalizeTransferNumber(item?.transfer_number);
    return sipClientId && transferNumber
      ? `transfer:${complexId}:${sipClientId}:${transferNumber}`
      : "";
  }

  return "";
}

export function createComplexSelectionItem(complex, cityLabel) {
  return {
    entityType: "complex",
    complexId: complex?._id,
    snapshot: {
      complexName: complex?.name || "Без названия",
      city: cityLabel || complex?.city || "—",
      rootStatus: complex?.status,
      currentSipClient: complex?.currentSipClient || "",
      currentSipClientId: String(complex?.currentSipClientId || ""),
    },
  };
}

export function createSipClientSelectionItem(row) {
  return {
    entityType: "sipClient",
    complexId: row?.complexId,
    sipClientId: row?.sipClientId,
    clientName: row?.clientName,
    snapshot: {
      complexName: row?.complexName || "Без названия",
      developer: row?.developer || "",
      sipNumber: row?.sip_number ?? "",
      transferNumber: row?.transfer_number ?? "",
      type: row?.type || "",
      clientStatus: row?.clientStatus,
      currentSipClient: row?.currentSipClient || "",
      currentSipClientId: row?.currentSipClientId || "",
      complexStatus: row?.complexStatus,
    },
  };
}

export function prepareUniqueSipItems(items) {
  const unique = new Map();

  items.forEach((item) => {
    if (item?.entityType !== "sipClient") return;
    const key = getWorkspaceSelectionKey(item);
    if (key) unique.set(key, item);
  });

  return Array.from(unique.values());
}

export function createTransferSelectionItem(row) {
  return {
    type: "transfer",
    complexId: row?.complexId,
    sipClientId: row?.sipClientId,
    complexName: row?.complexName || "Без названия",
    clientName: row?.clientName || "",
    transfer_number: row?.transfer_number ?? "",
    clientStatus: row?.clientStatus ?? row?.status,
  };
}

export function createSipClientSelectionItemFromTransfer(item) {
  return {
    entityType: "sipClient",
    complexId: item?.complexId,
    sipClientId: item?.sipClientId,
    clientName: item?.clientName,
    snapshot: {
      complexName: item?.complexName || "Без названия",
      transferNumber: item?.transfer_number ?? "",
    },
  };
}

export function sanitizeWorkspaceSelection(value) {
  if (!Array.isArray(value)) return [];

  const uniqueItems = new Map();

  value.forEach((item) => {
    const key = getWorkspaceSelectionKey(item);
    if (!key) return;

    uniqueItems.set(key, item.type === "transfer"
      ? {
          type: "transfer",
          complexId: String(item.complexId),
          sipClientId: String(item.sipClientId || ""),
          complexName: String(item.complexName || ""),
          clientName: String(item.clientName || ""),
          transfer_number: item.transfer_number,
          ...(typeof item.clientStatus === "boolean" ? { clientStatus: item.clientStatus } : {}),
        }
      : {
          entityType: item.entityType,
          complexId: String(item.complexId),
          ...(item.entityType === "sipClient" ? { clientName: String(item.clientName || "") } : {}),
          ...(item.entityType === "sipClient" ? { sipClientId: String(item.sipClientId || "") } : {}),
          snapshot: sanitizeSnapshot(item.snapshot, item.entityType),
        });
  });

  return Array.from(uniqueItems.values());
}
